import { Directive, HostListener, Input, inject } from '@angular/core';
import { AppEvent, AppEventTypeEnum, EventDispatcherService } from 'taxtank-core';

@Directive({
  selector: '[appOpenChat]',
  standalone: false
})
export class OpenChatDirective {
  private eventDispatcherService = inject(EventDispatcherService);

  @Input('appOpenChat') employeeId: number;

  

  @HostListener('click')
  onClick(): void {
    this.eventDispatcherService.dispatch(new AppEvent(AppEventTypeEnum.CLIENT_OPEN_CHAT, this.employeeId));
  }
}
